import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";

import styles from "./BackToTopFAB.module.css";

const BackToTopFAB = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Function to detect scroll position
  const toggleVisibility = () => {
    // console.log("window.scrollY: ", window.scrollY)
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Function to scroll to the top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Setting up event listener for scroll
  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    // console.log("after scrol check")
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div className={styles.fabContainer}>
      {isVisible && (
        <Button onClick={scrollToTop} className={styles.fab}>
          &#8679;
        </Button>
      )}
    </div>
  );
};

export default BackToTopFAB;
